
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu",
      function () {
        return require("private-next-pages/alu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu"])
      });
    }
  